import React from 'react'

import Description from './Description';
import IconsSection from './IconsSection';

const MainView = () => {
  return (
    <div className="simple-service main-view text-format">
      <div className="container">
        <Description />
        <IconsSection />
      </div>
    </div>
  )
}

export default MainView
